<template>
    <span class="custom-line-placeholder" @click="onAddCustomLine">
        <span class="custom-line-placeholder__line"></span>
        <AddIconSvg class="custom-line-placeholder__icon" />
        <span class="custom-line-placeholder__line"></span>
    </span>
</template>

<script>
import { gConsts } from '@/globals/gConsts';
import { mapActions } from 'vuex';

import AddIconSvg from '@/assets/icons/add.svg';

export default {
    name: 'customLinePlaceholder',
    components: {
        AddIconSvg,
    },
    props: {
        orderIndex: {
            type: Number,
            required: false
        },
        parent: {
            type: String,
            required: false
        },
    },
    data() {
        return {
            gConsts: gConsts,
        }
    },
    methods: {
        ...mapActions([
            'ACT_report_addCustomLineText',
        ]),
        onAddCustomLine() {
            this.ACT_report_addCustomLineText({ text: '', orderIndex: this.orderIndex, parent: this.parent });
        },
    },
}
</script>

<style scoped>

.custom-line-placeholder {
    display: flex;
    align-items: center;
    gap: var(--spacing-sm);
    flex-shrink: 0;
    width: 100%;
    cursor: text;
    opacity: 0;
    margin-top: 2px;
    padding-block: 2px;
    overflow: hidden;
    transition: opacity 0.2s ease, max-height 0.5s ease;
}

.custom-line-placeholder:hover {
    opacity: 1;
    max-height: none;
    border-left: 3px solid #ccc;
    padding-left: var(--spacing-xs);
}

.custom-line-placeholder__icon {
    width: 16px;
    height: 16px;
    color: var(--color-primary);
    flex-shrink: 0;
    transition: opacity 0.2s ease;
}

.custom-line-placeholder__icon:hover {
    opacity: 0.6;
}

.custom-line-placeholder__line {
    display: inline-block;
    width: 100%;
    height: 1px;
    background-color: var(--border-primary);
    opacity: 0.5;
}
</style>